// extracted by mini-css-extract-plugin
export default {"form":"styles_form__Zhape","title":"styles_title__wDcAC","alt":"styles_alt__o-KOJ","hidden":"styles_hidden__Fv3vj"};